import { Component, OnInit, Input, EventEmitter, Output, forwardRef, ViewChild, ViewEncapsulation, Injector } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { NgbModalRef, NgbModal } from '../../../../../../node_modules/@ng-bootstrap/ng-bootstrap';
import { FileViewerComponent } from '../file-viewer/file-viewer.component';
import { UserService } from '../../../services/user.service';
import { VsFileItem } from '../../file-upload/models/file-item';
import { VsFileUploadService } from '../services/file-upload.service';
import { DialogService, DynamicDialogRef } from 'primeng/primeng';
import { DocumentViewerComponent } from '../document-viewer/document-viewer.component';
import { FileType } from '../../../../dapfood/common/constant';
import { ComponentBase } from '../../../classes/base/component-base';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'vs-fs-list-file',
    templateUrl: './list-file.component.html',
    styleUrls: ['./list-file.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => VsFsListFileComponent),
            multi: true
        }
    ],
    encapsulation: ViewEncapsulation.None
})
export class VsFsListFileComponent extends ComponentBase implements OnInit, ControlValueAccessor {
    files: VsFileItem[] = [];
    disabled = false;
    ids = [];
    userId: number;
    linkView = '';
    selectedFile: VsFileItem = new VsFileItem();
    modalReference: NgbModalRef;
    ref: DynamicDialogRef;
    @ViewChild('fileViewer') fileViewer: NgbModal;

    @Input() currentIds = '';
    @Input() isMngFile = false;
    @Input() viewOnly = false;
    @Input() isSingleFile = false;
    @Output() onUploaded: EventEmitter<any> = new EventEmitter<any>();
    @Output() onRemoved: EventEmitter<any> = new EventEmitter<any>();
    @Output() onClick: EventEmitter<any> = new EventEmitter<any>();
    @Output() onSelectItem: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild(FileViewerComponent) _FileViewerComponent: FileViewerComponent;

    constructor(
        protected _injector: Injector,
        private _fileService: VsFileUploadService,
        private ngbModal: NgbModal,
        private _userService: UserService,
        public dialogService: DialogService,
    ) {
        super();
    }

    ngOnInit() {
        this.userId = this._userService.getBasicUserInfo().userId;
    }

    onChangeControl = (obj: any) => { };
    onTouched = () => { };

    writeValue(obj: VsFileItem[]): void {
        if (obj) {
            this.files = obj;
        }
    }

    registerOnChange(fn: any): void {
        this.onChangeControl = fn;
    }
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    openFile(item: VsFileItem) {

    }
    deleteFile(item: VsFileItem) {
        if (item.isFolder === true) {
            this._fileService.deleteFolder(this.userId, item.id);
            const fileToRemove = this.files.findIndex(x => x.fileName === item.fileName);
            this.files.splice(fileToRemove, 1);
        } else {
            this._fileService.deleteFile(item);
            const fileToRemove = this.files.findIndex(x => x.fileName === item.fileName);
            this.files.splice(fileToRemove, 1);
            this.onChangeControl(this.files);
            this.onRemoved.next(item);
        }
    }

    deleteFileTemp(item: VsFileItem) {
        if (item.isFolder === true) {
            const fileToRemove = this.files.findIndex(x => x.fileName === item.fileName);
            this.files.splice(fileToRemove, 1);
        } else {
            const fileToRemove = this.files.findIndex(x => x.fileName === item.fileName);
            this.files.splice(fileToRemove, 1);
            this.onChangeControl(this.files);
            this.onRemoved.next(item);
        }
    }

    viewFile(item: VsFileItem) {
        if (item.type == FileType.Image || item.type == FileType.Video) {
            this.ref = this.dialogService.open(FileViewerComponent, {
                data: {
                    file: item,
                },
                showHeader: false,
                width: '100%',
                height: 'calc(100vh)',
                styleClass: "vs-modal",
                contentStyle: { 'overflow': 'auto', 'position': 'relative' },
                baseZIndex: 1100,
                closeOnEscape: true,
            });
        }
        else {
            this.ref = this.dialogService.open(DocumentViewerComponent, {
                data: item,
                showHeader: true,
                header: item.fileName,
                width: '100%',
                height: 'calc(100vh - 0px)',
                styleClass: "vs-modal vs-file-viewer",
                contentStyle: { 'overflow': 'auto' }, //'max-height': 'calc(100vh - 180px);', 
                baseZIndex: 1100,
                closeOnEscape: true
            });
        }
    }

    async onItemClick(item: VsFileItem) {
        this.selectedFile = new VsFileItem();
        if (item.isFolder === true) {
            this.onChangeControl(this.files);
            this.onClick.next(item);
        } else {
            this.viewFile(item);
        }
    }

    checkItem(item) {
        if (this.isSingleFile) {
            this.files.forEach(element => {
                if (element.id !== item.id) {
                    element.checked = false;
                }
            });
            if (item.checked) {
                this.ids = [];
                this.ids.push(item.id);
                item.checked = true;
            } else {
                this.ids.splice(this.ids.indexOf(item.id), 1);
                item.checked = false;
            }
            this.onChangeControl(this.ids);
            this.onSelectItem.next(this.ids + '');
        } else {
            this.ids = this.currentIds.split(',').filter(s => s !== '');
            if (item.checked) {
                // Kiểm tra nếu Id chưa có trong currentIds thì bổ sung
                if (this.currentIds.indexOf(item.id + ',') < 0 && this.currentIds.indexOf(',' + item.id) < 0) {
                    this.ids.push(item.id);
                    item.checked = true;
                    this.onSelectItem.next(this.ids + ',');
                }
            } else {
                // Kiểm tra nếu Id có trong currentIds thì remove để xóa
                this.currentIds = this.currentIds.replace(item.id + ',', '');
                this.currentIds = this.currentIds.replace(',' + item.id, '');
                this.ids.splice(this.ids.indexOf(item.id), 1);
                item.checked = false;
                this.onSelectItem.next(this.currentIds);
            }
            this.onChangeControl(this.ids);
        }


        // alert(this.ids + this.currentIds);
    }

    onClose() {
        this.modalReference.close();
    }
}
